export default __webpack_public_path__ + "c872bc74fc67c2304d51c865b4148330.svg";